  let sortedFilters = FiltersToSort;
  sortedFilters.forEach(filter => {
    const key = Object.keys(rankMap).find(key => filter.value.includes(key));
    filter.rank = key ? rankMap[key] : 777;
  });

  sortedFilters = sortedFilters.sort((a,b) => a.rank - b.rank);
  for (let i = 0; i < sortedFilters.length; i++){
    createFilterInput(sortedFilters[i].container, sortedFilters[i].name, sortedFilters[i].value, sortedFilters[i].collectionHandle, sortedFilters[i].value.replaceAll("_", " "));
  }

  bayFilters = bayFilters.sort((a,b) => a.rank - b.rank);
  bayFilters.reverse();
    for (let i = 0; i < bayFilters.length; i++){
      createFilterInput(bayFilters[i].container, bayFilters[i].name, bayFilters[i].value, bayFilters[i].collectionHandle, bayFilters[i].value.replaceAll("b", " Bays"));
    }

function filterBubbleClickHandler(event) {
    const filterBubble = event.target.closest('.filterBubble');
    const filterValue = filterBubble.getAttribute('data-filter');
    const allFilters = document.querySelectorAll('.brandFilter input');
    const filterInput = [...allFilters].find(filter => filter.value === filterValue);
    filterBubble.style.transition = 'opacity 0.1s';
    filterBubble.style.opacity = '0';
    setTimeout(() => {
        filterInput.checked = false;
        filterInput.dispatchEvent(new Event('change'));
    }, 100);
}

function createFilterBubbles(filters) {

    const filterLabelMap = {
        "1cpu": '1 CPU',
        "2cpu": '2 CPU',
        "4cpu": '4 CPU',
        "6cpu": '6 CPU',
        "true": 'NVMe Capable',
        "LFF": 'SAS/SATA 3.5"',
        "SFF": 'SAS/SATA 2.5"',
        "24b": '24 Bays',
        "16b": '16 Bays',
        "12b": '12 Bays',
        "10b": '10 Bays',
        "8b": '8 Bays',
        "4b": '4 Bays',
        "3b": '3 Bays',
        "2b": '2 Bays',
        "1b": '1 Bay',
        'HP 9Th': 'HP G9',
        'HP 10Th': 'HP G10',
        'HP 11Th': 'HP G11',
        'HP 12Th': 'HP G12',
        'Dell 13Th': 'Dell 13Th Generation',
        'Dell 14Th': 'Dell 14Th Generation',
        'Dell 15Th': 'Dell 15Th Generation',
        'Dell 16Th': 'Dell 16Th Generation',
        'Cisco M3': 'Cisco M3',
        'Cisco M4': 'Cisco M4',
        'Cisco M5': 'Cisco M5',
        'Cisco M6': 'Cisco M6',
        'Cisco M7': 'Cisco M7',
    };
    

    const filterAnchor = document.querySelector('#collection-filter-anchor');
    if (window.innerWidth < 768) {
        const mobileFilterBubbleContainer = document.querySelector('.filterBubbleContainer').cloneNode(true);
        const prodCollAnchor = document.querySelector('#product-collection-anchor');
        mobileFilterBubbleContainer.classList.add('mobileFilterBubbleContainer');
        document.querySelector('.filterBubbleContainer').remove();
        prodCollAnchor.insertBefore(mobileFilterBubbleContainer, document.querySelector('#prodCountContainer'));
    }
    if (!document.querySelector('.filterBubbleContainer')) {
        const filterBubbleContainer = document.createElement('div');
        filterBubbleContainer.classList.add('filterBubbleContainer');
        if (window.innerWidth > 768) {
            filterAnchor.insertBefore(filterBubbleContainer, filterAnchor.firstChild);
            document.querySelector("#sort-by").style.marginLeft = '3.14%';

        } else {
            console.log('mobile');
            filterBubbleContainer.style.justifyContent = 'center';
            filterAnchor.parentNode.insertBefore(filterBubbleContainer, document.querySelector('#prodCountContainer'));  
        
        }
    } else{
        document.querySelector('.filterBubbleContainer').innerHTML = '';
    }
    for (let i in filters) {
        for (let j in filters[i]){
            let filterBubbleContainer = document.querySelector('.filterBubbleContainer');

            if (!document.querySelector(`.filterBubble-${filters[i][j].replaceAll(" ", "-").replaceAll("/", "-")}`)) {
                const filterBubble = document.createElement('div');
                filterBubble.classList.add('filterBubble');
                filterBubble.classList.add(`filterBubble-${filters[i][j].replaceAll(" ", "-").replaceAll("/", "-")}`);
                filterBubble.innerHTML = filterLabelMap[filters[i][j].replaceAll("_", " ")] || filters[i][j].replaceAll("_", " ");
                filterBubble.innerHTML += '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg>';
                filterBubble.setAttribute('data-filter', filters[i][j]);
                filterBubbleContainer.appendChild(filterBubble);
                filterBubble.addEventListener('click', filterBubbleClickHandler);
            }
        }
    
    }
}



function applyFiltersForCTOClientSide(collection) {
    const productsOnPageCache = JSON.parse(localStorage.getItem('productsOnPage')) || [];

    let selectedFilters = {
        brand: [],
        formFactor: [],
        rackUnit: [],
        baysize: [],
        bays: [],
        cpuFamily: [],
        noCPU: [],
        nvmeCapable: [],
        warranty: [],
        format: [],
        vxrail: [],
        precision: []
    };

    document.querySelectorAll('.brandFilter input:checked').forEach(filter => {
        switch (filter.name) {
            case 'BF':
                selectedFilters.brand.push(filter.value);
                break;
            case 'form_factor':
                selectedFilters.formFactor.push(filter.value);
                break;
            case 'rackUnit':
                selectedFilters.rackUnit.push(filter.value);
                break;
            case 'baysize':
                selectedFilters.baysize.push(filter.value);
                break;
            case 'cpu_family':
                selectedFilters.cpuFamily.push(filter.value);
                break;
            case 'numberofbays':
                selectedFilters.bays.push(filter.value);
                break;
            case 'no_cpu':
                selectedFilters.noCPU.push(filter.value);
                break;
            case 'nvmeCapable':
                console.log(nvmeCapable);
                selectedFilters.nvmeCapable.push(filter.value);
                break;
            case 'warranty':
                selectedFilters.warranty.push(filter.value);
                break;
            case 'format':
                selectedFilters.format.push(filter.value);
                break;
            case 'vxrail':
                selectedFilters.vxrail.push(filter.value);
                break;
            case 'precision':
                selectedFilters.precision.push(filter.value);
                break;
            default:
                break;
        }
    });

    productsOnPage = productsOnPageCache.filter(product => {
        let matchesBrand = selectedFilters.brand.length === 0 || selectedFilters.brand.includes(product.productDetails.brandFilter);
        let matchesFormFactor = selectedFilters.formFactor.length === 0 || selectedFilters.formFactor.includes(product.productDetails.form_factor);
        let matchesRackUnit = selectedFilters.rackUnit.length === 0 || selectedFilters.rackUnit.includes(product.productDetails.rackUnit);
        let matchesBaySize = selectedFilters.baysize.length === 0 || selectedFilters.baysize.includes(product.productDetails.baysize);
        let matchesBays = selectedFilters.bays.length === 0 || selectedFilters.bays.includes(product.productDetails.bays);
        let matchesCPUFamily = selectedFilters.cpuFamily.length === 0 || selectedFilters.cpuFamily.includes(product.productDetails.cpuFamily);
        let matchesNoCPUs = selectedFilters.noCPU.length === 0 || selectedFilters.noCPU.includes(product.productDetails.noCPU);
        let matchesNVMeCapable = selectedFilters.nvmeCapable.length === 0 || selectedFilters.nvmeCapable.includes(product.productDetails.nvmeCapable);
        let matchesWarranty = selectedFilters.warranty.length === 0 || selectedFilters.warranty.includes(product.productDetails.warranty);
        let matchesFormat = selectedFilters.format.length === 0 || selectedFilters.format.includes(product.productDetails.format);
        let matchesVxrail = selectedFilters.vxrail.length === 0 || selectedFilters.vxrail.includes(product.productDetails.vxrail);
        let matchesPrecision = selectedFilters.precision.length === 0 || selectedFilters.precision.includes(product.productDetails.precision);

        return matchesBrand && matchesFormFactor && matchesRackUnit && matchesBaySize && matchesBays && matchesCPUFamily && matchesNoCPUs && matchesWarranty && matchesFormat && matchesNVMeCapable && matchesVxrail && matchesPrecision;
    });

    
    let pageSize =200

    document.querySelectorAll('.brandFilter input').forEach(filter => {
        let isFilterValueInProducts = productsOnPage.some(product => {
            switch (filter.name) {
                case 'BF':
                    return product.productDetails.brandFilter === filter.value;
                case 'form_factor':
                    return product.productDetails.form_factor === filter.value;
                case 'rackUnit':
                    return product.productDetails.rackUnit === filter.value;
                case 'baysize':
                    return product.productDetails.baysize === filter.value;
                case 'cpu_family':
                    return product.productDetails.cpuFamily === filter.value;
                case 'numberofbays':
                    return product.productDetails.bays === filter.value;
                case 'no_cpu':
                    return product.productDetails.noCPU === filter.value;
                case 'nvmeCapable':
                    return product.productDetails.nvmeCapable === filter.value;
                case 'warranty':
                    return product.productDetails.warranty === filter.value;
                case 'format':
                    return product.productDetails.format === filter.value;
                case 'vxrail':
                    return product.productDetails.vxrail === filter.value;
                case 'precision':
                    return product.productDetails.precision === filter.value;
                default:
                    return false;
            }
        });
        const filterSpan = filter.closest('span');
        if (isFilterValueInProducts) {
            filterSpan.style.opacity = '1';
        } else {
            if (filterSpan.querySelector('input').name !== 'BF'){
                filterSpan.style.opacity = '0.5';
            }
        }
    });
    if (selectedFilters) {
        createFilterBubbles(selectedFilters);
    }
    createProducts(productsOnPage, pageSize, 0);
}